<template>
<div>
  <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr class="heading">
          <th width="1%" class="text-center">#</th>
          <th width="20%" class="text-center">کالا</th>
          <th width="3%" class="text-center">امانی</th>
          <th width="15%" class="text-center">مقدار</th>
          <th width="17%" class="text-center">قیمت واحد</th>
          <th width="22%" class="text-center">مبلغ</th>
          <th width="16%" class="text-center">توضیحات</th>
          <th width="7%" class="text-center">عملیات</th>
        </tr>
      </thead>

      <tbody>
        <template v-for="(item, index) in items">
          <tr class="item" :key="item.row_id" v-if="!item.discount">
            <td id="pt">{{ index + 1 }}</td>
            <td>
              <MyProductsUnits
                v-model="item.product"
                @input="onChangeProduct(item)"
              />
            </td>
            <td><v-switch v-model="item.lending" :readonly="!item.product" /></td>
            <td>
              <MyFloat
                v-model="item.value"
                :readonly="!item.product"
                @focus="onFocusValue(item)"
                @input="onInputValue(item)"
                @blur="onBlur(item)"
              />
            </td>
            <td>
              <MyCurrency
                v-model="item.price"
                :readonly="!item.product"
                @input="onInputPrice(item)"
                @focus="item.product && getLocalStorage(item, index)"
                @blur="item.product && setLocalStorage(item)"
              />
            </td>
            <td>
              <MyCurrency
                v-model="item.total"
                :readonly="!item.product"
                @focus="onFocusTotal(item)"
                @input="onInputTotal(item, $event)"
                @blur="onBlur(item)"
              />
            </td>
            <td>
              <MyComment
                label="توضیحات"
                v-model="item.comment"
                :readonly="!item.product"
              />
            </td>
            <td id="pt">
              <v-icon
                color="success"
                class="mr-2"
                :class="{ 'v-icon--disabled': disabled }"
                @click="!disabled && addInvoiceRow(item)">
                mdi-plus</v-icon>
              <v-icon
                color="red darken-2"
                class="mr-2"
                :class="{ 'v-icon--disabled': disabled }"
                @click="!disabled && removeInvoiceRow(item)"
                v-if="items.length > 2"
              >mdi-delete</v-icon>
            </td>
          </tr>
        </template>

    <tr class="total">
      <td colspan="2" style="text-align: left">مانده باری :</td>
      <td colspan="2" style="text-align: right; color: green">
        {{ `${noneAbsDoubleDisplay(lendingBalance)} گرم (${noneAbsDoubleDisplay(lendingBalance * 0.217)} مثقال)` }}
      </td>
      <td colspan="1" style="text-align: left">جمع :</td>
      <td colspan="3" style="font-weight: bolder">{{ invoiceTotal | currencyDisplay }}</td>
    </tr>

    <template v-for="(item) in discountItems">
      <tr class="item" :key="'discount-' + item.row_id">
            <td colspan="4" style="vertical-align: middle;">تخفیف</td>
            <td colspan="1"><MyDiscount v-model="item.discount" /></td>
            <td colspan="3">
              <v-col class="mt-n3" sm="9">
                <DiscountPrice
                  v-model="item.price"
                  :total="invoiceTotal"
                  :route="route"
                  :discountLabel="item.discount.label"
                />
              </v-col>
            </td>
          </tr>
    </template>

    <tr class="total">
      <td colspan="5">مبلغ فاکتور</td>
      <td colspan="3">{{ invoicePrice | currencyDisplay }}</td>
    </tr>
    </tbody>
    </template>
  </v-simple-table>
</div>
</template>

<script>
import MyProductsUnits from '../../components/MyProductsUnits.vue'
import MyFloat from '../../components/MyFloat.vue'
import MyCurrency from '../../components/MyCurrency.vue'
import DiscountPrice from '../../components/Discount‌Price.vue'
import MyComment from '../../components/MyComment.vue'
import MyDiscount from '../../components/MyDiscount.vue'

export default {
  name: 'invoiceTable',
  props: [
    'route', 'items', 'lendingBalance', 'invoiceTotal', 'invoicePrice',
    'addInvoiceRow', 'removeInvoiceRow', 'getLocalStorage', 'setLocalStorage',
    'disabled'
  ],
  components: {
    MyProductsUnits,
    MyFloat,
    MyCurrency,
    DiscountPrice,
    MyComment,
    MyDiscount
  },
  computed: {
    discountItems() {
      return this.items.filter(item => item.discount)
    }
  },
  watch: {
    items: {
      handler(newItems) {
        newItems.forEach(item => {
          if (!item.total) item.total = this.calculateTotal(item)
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onChangeProduct(item) {
      item.value = null
      item.total = null
    },

    onFocusValue(item) {
      item.lockedField = 'value'
    },

    onInputValue(item) {
      if (item.lockedField !== 'value') return
      const raw = String(item.value).replace(',', '')
      if (!isNaN(raw)) {
        item.value = Math.ceil(Number(raw) * 1000) / 1000
        item.total = this.calculateTotal(item)
      } else {
        item.total = null
      }
    },

    onBlur(item) {
      item.lockedField = null
    },

    onInputPrice(item) {
      const raw = String(item.price).replace(',', '')
      if (isNaN(raw)) {
        item.total = null
        return
      }
      //
      item.total = this.calculateTotal(item)
    },

    onFocusTotal(item) {
      item.lockedField = 'total'
    },

    onInputTotal(item, newTotal) {
      if (item.lockedField !== 'total') return
      if (isNaN(newTotal) || !item.product) return
      //
      item.total = newTotal
      if (item.price) {
        const value = newTotal / (item.price * item.product.n)
        item.value = Math.ceil(Number(value) * 1000) / 1000
      }
    },

    calculateTotal(item) {
      if (!item.product || !item.value || !item.price) return 0
      const value = parseFloat(item.value) || 0
      const price = parseInt(item.price) || 0
      const n = parseFloat(item.product.n) || 1
      return Math.round((value * price * n) / 10) * 10
    },

  }
}
</script>
<style media="screen">
.v-icon--disabled {
  opacity: 0.4;
  pointer-events: none;
}
</style>
